exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-SurveySummary {\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  margin: 10px;\n  max-width: 100%;\n}\n@media print {\n  .cs-SurveySummary__print {\n    display: none;\n  }\n}\n.cs-SurveySummary__bottomButtons {\n  display: inline;\n  margin: 25%;\n}\n.cs-PDFScale {\n  margin: 450px;\n  width: 900px;\n  background-color: #f00;\n  transform: scale(2, 2);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/SurveySummary/SurveySummary.less
// module id = 932
// module chunks = 0